import { Dispatch, SetStateAction } from 'react';
import { isNull } from 'lodash';

export const handleChange = (
  setPercent: Dispatch<SetStateAction<number | null | undefined>>,
  onChange?: (value: number | null) => void,
) => (
  val: number | null,
) => {
  setPercent(val);

  if (isNull(val)) {
    onChange?.(null);
    return;
  }

  onChange?.(Number(val) / 100);
};
